/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as TYPES from './action-types';
const intialState = {
  loading: false,
  userDefault: null,
  planType: 'FD',
  selectType: 'INELEGPRO',
  actionType: 'INVOICE',
  rebateDropdownData: [],
  errorMessages: [],
  drugFamilyCode: [],
  selectedRow: {},
  processResponse: null,
  searchScrErr: [],
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case TYPES.SET_PLAN_TYPE:
      return { ...state, planType: action.payload };
    case TYPES.SET_SEARCH_ERROR_MSG:
      return { ...state, searchScrErr: action.payload };
    case TYPES.OMITTED_CLAIM_TABLE_REBATE_PROGRAM_DATA:
      return { ...state, rebateDropdownData: action.payload };
    case TYPES.SET_SELECT_TYPE:
      return { ...state, selectType: action.payload };
    case TYPES.SET_ACTIONS_TYPE:
      return { ...state, actionType: action.payload };
    case TYPES.RESET_REQUEST_CLAIM_DATA:
      return { ...intialState };
    case TYPES.SET_DRUG_FAMILY_DETAILS:
      return { ...state, drugFamilyCode: action.payload };
    case TYPES.SET_SELECTED_DRUG_FAMILY_ROW:
      return { ...state, selectedRow: action.payload };
    case TYPES.DRUG_FAMILY_PROCESS_RESPONSE:
      return { ...state, processResponse: action.payload };
    default:
      return state;
  }
};

export default reducer;
